import React from 'react';

interface IProps {
  lang: string;
}

const LocaleIcon = React.memo(({ lang }: IProps) => (
  <img src={require(`../../../../assets/images/locales/${lang}.svg`)} alt={lang} />
));

export default LocaleIcon;
